import React from 'react';
import PropTypes from 'prop-types';

import Text from '../Text';

const ReplacementText = ({type, ...rest}) => {
  const TITLE = {
    none: 'Geen keuze',
    wait: 'Wachten op locatie',
    message: 'Bericht ontvangen',
    bike: 'Leenfiets',
    transport: 'Haal- en brengservice',
    car: 'Huurauto',
  };

  return <Text {...rest}>{TITLE[type] ?? 'Vervangend vervoer'}</Text>;
};

ReplacementText.propTypes = {
  type: PropTypes.any,
};

export default ReplacementText;
